import inspector from "./inspector";
import manager from "./manager";
import responsible from "./responsible";

const regularUser = {
  'INSPECTOR': inspector,
  'MANAGER': manager,
  'RESPONSIBLE': responsible
}

export default regularUser